import mixpanel from "mixpanel-browser";

export const logEvent = async (eventName, eventValues = {}) => {
  try {
    mixpanel.track(eventName, eventValues);
  } catch (e) {
    console.log("mixpanel event error", e);
  }
};
